<template>
  <div class="tour-important">
    <extension v-for="{ header, body } in items" :key="header">
      <template #header>
        <div v-html="header"></div>
      </template>
      <template #body>
        <div class="font-regular" v-html="body"></div>
      </template>
    </extension>
    <extension>
      <template #header>
        <div v-html="$t('serpDetail.important.book.title')"></div>
      </template>
      <template #body>
        <i18n
          path="serpDetail.important.book.text"
          tag="div"
          class="font-regular"
        >
          <template #action>
            <span
              class="u-clickable u-text-green-dark"
              v-html="$t('serpDetail.important.book.action')"
              @click="$emit('book')"
            ></span>
          </template>
          <template #ask>
            <span
              class="u-clickable u-text-green-dark"
              v-html="$t('serpDetail.important.book.ask')"
              @click="$emit('ask')"
            ></span>
          </template>
        </i18n>
      </template>
    </extension>
  </div>
</template>

<script>
import Extension from "@/components/ui-kit/extension/index.vue";

export default {
  components: {
    Extension,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      const {
        tour: {
          common = "",
          custom_cancellation = "",
          demands = "",
          visa_info = "",
          covid_info = "",
        },
      } = this;
      const items = [];

      if (common) {
        items.push({
          header: this.$t("serpDetail.important.common"),
          body: common,
        });
      }

      if (custom_cancellation) {
        items.push({
          header: this.$t("serpDetail.important.customCancellation"),
          body: custom_cancellation,
        });
      }

      if (demands) {
        items.push({
          header: this.$t("serpDetail.important.demands"),
          body: demands,
        });
      }

      if (visa_info) {
        items.push({
          header: this.$t("serpDetail.important.visa"),
          body: visa_info,
        });
      }

      if (covid_info) {
        items.push({
          header: "Covid-19",
          body: covid_info,
        });
      }

      items.push({
        header: this.$t("serpDetail.important.prepay.title"),
        body: this.$t("serpDetail.important.prepay.text"),
      });

      return items;
    },
  },
};
</script>
